import Vue from 'vue';
import Router from 'vue-router'
import publicObj from '../assets/js/public'
import wxConfig from '../assets/js/wx.config'
import wxShare from '../assets/js/wx.share'
import store from '../store/index'
import { Toast } from 'vant';

import home from './home/index'
import order from './order/index'
import casee from './case/index'
import my from './my/index'
import login from './login/index'
import mentionMe from './mentionMe/index'
import pullNew from './pullNew/index'
import bargaining from './bargaining/index'
import game from './game/index'
// 进度条

Vue.use(Router)
let routers = []
const noLoginRouter = [
  'chenzhen',
  'homeActiveIndex',
  'couponPageIndex',
  'game',
  'doll',
  'login',
  'mentionMeIndex',
  'pullNewIndex',
  'customPageIndex',
  'sendFeedbackIndex',
  'sendFeedbackNoIndex',
  'homeIndex',
  'caseIndex',
  'agreement',
  'about',
  'homeList',
  'serviceDetail',
  'caseDetail',
  'caseSearch',
  'feeScale',
  'scope',
  'homeListNew',
  'teamDetail',
  'metalFilm',
  'leadIndex',
  'agreementDoc',
  'rabbitIndex',
  'recipientIndex',
  'configShareIndex',
  'bagGameIndex'
  // 'growthShare'
];

// const routerContext = require.context('./', true, /\.js$/)
// routerContext.keys().forEach(router => {
//   if (router.startsWith('./index')) {
//     return null
//   }
//   const routerModules = routerContext(router) || '';
//   routers = routers.concat(routerModules.default)

// })
routers = routers.concat(bargaining)
routers = routers.concat(pullNew)
routers = routers.concat(mentionMe)
routers = routers.concat(home)
routers = routers.concat(order)
routers = routers.concat(casee)
routers = routers.concat(my)
routers = routers.concat(login)
routers = routers.concat(game)

let myRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routers
})

let once = true;
myRouter.beforeEach((to, from, next) => {

  //设置用户来源
  if(to.query.source){
    store.commit('setSource',to.query.source);
    store.commit('setUoPageId',to.query.pageNum,to.query.bzSource);
  }
  store.commit('setrouterIndex')
  if (publicObj.isWeiXin() && to.name != 'share') {
    if (publicObj.isPlatform() === 'ANDROID') {
      wxConfig({path: location.origin + to.fullPath})
    } else {
      if (once)
      wxConfig({path: location.origin + to.fullPath});
      once = false
    }
  }

  if (publicObj.isWeiXin() && to.name != 'share' && to.name != 'homeBag'&& to.name != 'sendIndex' && to.name != 'homeActiveIndex' && to.name != 'couponPageIndex') {
    wxShare();
  }
  let noLoginFlag = false;
  for(let i in noLoginRouter){
    // console.log(to.name +','+noLoginRouter[i])
    if(to.name === noLoginRouter[i]){
      //当前页面不需要登录
      noLoginFlag = true;
      break;
    }
  }
  if(to.query&&to.query.pageFlag==1){
    noLoginFlag = true;
  }
  if(!noLoginFlag){
  
    if(to.query.customerIdGo){
      next()
    }else{
      if(store.state.token){
        
        next();
      }else {
        //记录当前url 便于登录后跳转
        sessionStorage.setItem('url', location.protocol + '//' + location.host + to.path + '?' + formateObjToParamStr(to.query));
        
        next({name: 'login'})
      }
    }
    
  }else {
    
    next()
  }
  
});

function filter(str) { // 特殊字符转义
  str += ''; // 隐式转换
  str = str.replace(/%/g, '%25');
  str = str.replace(/\+/g, '%2B');
  str = str.replace(/ /g, '%20');
  str = str.replace(/\//g, '%2F');
  str = str.replace(/\?/g, '%3F');
  str = str.replace(/&/g, '%26');
  str = str.replace(/\=/g, '%3D');
  str = str.replace(/#/g, '%23');
  return str;
}

function formateObjToParamStr(paramObj) {
  const sdata = [];
  for (let attr in paramObj) {
    sdata.push(`${attr}=${filter(paramObj[attr])}`);
  }
  return sdata.join('&');
};
myRouter.afterEach((to,from,next) => {

  if (to.meta.title) {
    document.title = to.meta.title
  }

  window.scrollTo(0,0);
});

export default myRouter
